import localeService from 'commons/localeService/localeService';

function initZendeskChat() {
  return new Promise(function (resolve, reject) {
    const ze = document.createElement('script');
    ze.async = true;
    ze.src =
      'https://static.zdassets.com/ekr/snippet.js?key=9517d693-627b-4a5d-9c45-3862386345bf';
    ze.onload = resolve;
    ze.onerror = reject;
    ze.id = 'ze-snippet';
    const s = document.getElementsByTagName('script')[0];
    s.parentNode?.insertBefore(ze, s);
  });
}

function isEnabled() {
  return Boolean(SPRD.LIVECHAT_ACTIVE);
}

type CustomVariable = { id: string; value: string };

async function init(
  customVariables: CustomVariable[] = [],
  onUnreadMessages: (count: number) => void,
) {
  if (!isEnabled()) {
    return;
  }

  await initZendeskChat();
  window.zE(
    'messenger:set',
    'locale',
    localeService.getLanguageFromLocale(localeService.getLocale()),
  );
  window.zE('messenger:set', 'conversationFields', customVariables);
  window.zE('messenger:set', 'zIndex', 100);
  // Zendesk keeps its open state in sessionStorage ('ZD-widgetOpen') and would
  // reopen the window by itself on the next page load in the same tab.
  closeChat();

  window.zE('messenger:on', 'unreadMessages', function (count: number) {
    if (onUnreadMessages) {
      onUnreadMessages(count);
    }
  });
}

function closeChat() {
  if (!isEnabled()) {
    return;
  }

  window.zE('messenger', 'close');
}

function openChat() {
  if (!isEnabled()) {
    return;
  }

  window.zE('messenger', 'show');
  window.zE('messenger', 'open');
}

function onOpenChange(handlerFn: (open: boolean) => void) {
  if (!isEnabled()) {
    return;
  }

  window.zE('messenger:on', 'open', () => handlerFn(true));
  window.zE('messenger:on', 'close', () => handlerFn(false));
}

function clearSession() {
  if (!isEnabled()) {
    return;
  }

  window.zE('messenger:set', 'cookies', false);
  window.zE('messenger:set', 'cookies', true);
}

export default {
  isEnabled,
  init,
  closeChat,
  openChat,
  onOpenChange,
  clearSession,
};

export type { CustomVariable };
